import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/testimonials';
import { testimonialVideoSrc } from '../data/media';
export function Testimonials() {
  return <section aria-labelledby="testimonios-title" className="relative border-t border-silver/10 bg-night py-20 sm:py-28" data-id="element-172" data-mp="3fxuly2pkykrs">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-173" data-mp="36ypo6yluevgo">
        <SectionHeading id="testimonios-title" eyebrow="Comunidad" title="EXPERIENCIAS DE NUESTROS CLIENTES" data-id="element-174" data-mp="370akotrpwoh6" />

        <figure className="mx-auto mt-12 w-full max-w-3xl" data-id="element-175" data-mp="2x09x2vmtfm76">
          <div className="flex items-center justify-center overflow-hidden rounded-2xl border border-silver/20 bg-carbon shadow-card" data-id="element-176" data-mp="2x2w4mv9pi1pe">
            <video src={testimonialVideoSrc} className="block max-h-[32rem] w-auto max-w-full" controls playsInline preload="metadata" data-id="element-177" data-mp="v9yfb9f51r97">
              Tu navegador no admite la reproducción de video.
            </video>
          </div>
          <figcaption className="mt-4 text-center text-xs leading-relaxed text-silver/70" data-id="element-178" data-mp="m62os3lp85tb">
            Experiencia compartida por un cliente, publicada con su
            autorización.
          </figcaption>
        </figure>

        {testimonials.length > 0 ? <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-179" data-mp="zwfv61ixzcgj">
            {testimonials.map(testimonial => <li key={`${testimonial.name}-${testimonial.quote.slice(0, 12)}`} className="flex flex-col rounded-2xl border border-silver/15 bg-carbon/70 p-7" data-id="element-180" data-mp="14vskcsxacvma">
                <QuoteIcon className="h-5 w-5 text-accent-soft" aria-hidden="true" data-id="element-181" data-mp="v4o4lqzsd6qe" />
                <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-silver sm:text-[0.95rem]" data-id="element-182" data-mp="1it7cw6iu5jih">
                  {testimonial.quote}
                </blockquote>
                <figcaption className="mt-6 border-t border-silver/10 pt-5 text-[0.7rem] font-medium uppercase tracking-[0.2em] text-frost" data-id="element-183" data-mp="1xgpn1kf636ca">
                  {testimonial.name}
                  {testimonial.city ? <span className="block pt-1 tracking-[0.16em] text-silver/70" data-id="element-184" data-mp="1ofhpx5oe0bjs">
                      {testimonial.city}
                    </span> : null}
                </figcaption>
              </li>)}
          </ul> : <div className="mx-auto mt-14 max-w-2xl rounded-2xl border border-dashed border-silver/25 bg-carbon/50 p-9 text-center" data-id="element-185" data-mp="19rdcoh83ss8e">
            <QuoteIcon className="mx-auto h-6 w-6 text-accent-soft" aria-hidden="true" data-id="element-186" data-mp="14tlamudqvpqh" />
            <p className="mt-5 text-[0.95rem] leading-relaxed text-silver" data-id="element-187" data-mp="vsneey9jsmig">
              En esta sección publicamos únicamente experiencias reales
              compartidas por nuestros clientes, con su autorización previa.
            </p>
          </div>}
      </div>
    </section>;
}